import { formatBrussels } from './brussels-datetime';

const transformDate = (date: Date | string, locale: string) => formatBrussels(date, locale, {
	day: 'numeric',
	month: 'short',
	year: 'numeric',
});

const transformTime = (date: Date | string, locale: string) => formatBrussels(date, locale, {
	hour: 'numeric',
	minute: '2-digit',
});

const transformDatetime = (date: Date | string, locale: string, separator = ' - ') => {
	const datePart = transformDate(date, locale);
	const timePart = transformTime(date, locale);
	return `${datePart}${separator}${timePart}`;
};

export { transformDate, transformTime, transformDatetime };
